export default "__VITE_PUBLIC_ASSET__dd46101e__"